import React from 'react';
const STATS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '1 + 5',
  label: 'Box Set & Bonuses'
}, {
  value: 'Pro',
  label: 'Teaching Level'
}, {
  value: 'Worldwide',
  label: 'Digital Access'
}];
export function Stats() {
  return <section aria-label="Key numbers" className="w-full bg-petrol px-3 py-5 sm:px-5" data-id="element-202" data-mp="2ixpdiwpjpb2y">
      <div className="mx-auto max-w-5xl" data-id="element-203" data-mp="2nvh3hl6mqn4i">
        <p className="text-center font-head text-[10px] uppercase tracking-[0.14em] text-mustard sm:text-xs" data-id="element-204" data-mp="2985p7bj2cp0p">
          Built for special education teachers who want everything ready
        </p>
        <dl className="mt-3 grid grid-cols-2 gap-x-2 gap-y-3 lg:grid-cols-4" data-id="element-205" data-mp="207g16u01o2xj">
          {STATS.map(stat => <div key={stat.label} className="text-center" data-id="element-206" data-mp="256k8tg7blslr">
              <dt className="sr-only" data-id="element-207" data-mp="2572aiscr4z12">{stat.label}</dt>
              <dd className="font-head text-2xl uppercase leading-none text-white sm:text-4xl" data-id="element-208" data-mp="1q8rtop5or683">
                {stat.value}
              </dd>
              <p className="mt-1 text-[9px] font-bold uppercase tracking-widest text-white/60 sm:text-[11px]" data-id="element-209" data-mp="1v7v28jkvjukt">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}